import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { type AhaEventMap } from 'global_events';

interface CommentsSidePanelTabComponentProps {
  annotatableType: string;
  annotatableId: string;
}

const CommentsSidePanelTabComponent: React.FC<
  CommentsSidePanelTabComponentProps
> = ({ annotatableType, annotatableId }) => {
  const [hasUnresolvedComments, setHasUnresolvedComments] = useState(false);

  useEffect(() => {
    const eventName = 'aha.annotations-loaded';
    const listener = (event: AhaEventMap['aha.annotations-loaded']) => {
      const { detail } = event;
      if (
        !detail ||
        annotatableType !== detail.annotatableType ||
        annotatableId !== detail.annotatableId
      ) {
        return;
      }

      setHasUnresolvedComments(
        Number.isInteger(detail?.unresolvedCount) && detail?.unresolvedCount > 0
      );
    };
    document.addEventListener(eventName, listener);

    return () => document.removeEventListener(eventName, listener);
  }, [annotatableType, annotatableId]);

  if (!hasUnresolvedComments) {
    return null;
  }

  return (
    <aha-sidepanel-item>
      <span className={styles.commentTabNotification} />
      <i className='fa-regular fa-comment' />
    </aha-sidepanel-item>
  );
};

export default CommentsSidePanelTabComponent;
